module.exports = __webpack_public_path__ + "static/img/jiantou-zuo.583246e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoDetail/jiantou-zuo.png
// module id = iCdB
// module chunks = 0